import { type IFrontBreadcrumbsContainerProps } from '@framework/theme/front/container/FrontBreadcrumbsContainer.tsx';
import { createPortalSubject } from '@framework/ui/hooks/portal/usePortalSubject.ts';
import { useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';

const FRONT_BREADCRUMBS_PORTAL = 'front-breadcrumbs--portal';

const portalSubject = createPortalSubject();

/**
 * Permette di posizionare i Breadcrumbs.
 */
export function FrontBreadcrumbsContainer(
  props: IFrontBreadcrumbsContainerProps,
) {
  const el = useRef(document.createElement('div'));

  const rerenderCount = portalSubject.useRerenderCount();

  // biome-ignore lint/correctness/useExhaustiveDependencies: Force re-render
  useEffect(() => {
    const portal = document.getElementById(FRONT_BREADCRUMBS_PORTAL);
    if (!portal) {
      console.warn(
        `L'elemento con id "${FRONT_BREADCRUMBS_PORTAL}" non è stato trovato nel documento.  Assicurati che sia presente nel DOM prima di utilizzare il portale.`,
      );
      return;
    }

    portal.appendChild(el.current);

    return () => {
      portal.removeChild(el.current);
    };
  }, [rerenderCount]);

  return ReactDOM.createPortal(props.children, el.current);
}

export const FrontBreadcrumbsPortal = () => {
  portalSubject.useTrigger();

  return <div id={FRONT_BREADCRUMBS_PORTAL} />;
};
